import { render, staticRenderFns } from "./gallery-category-list.vue?vue&type=template&id=6f3deb1a&scoped=true&"
import script from "./gallery-category-list.vue?vue&type=script&lang=js&"
export * from "./gallery-category-list.vue?vue&type=script&lang=js&"
import style0 from "./gallery-category-list.vue?vue&type=style&index=0&id=6f3deb1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3deb1a",
  null
  
)

export default component.exports